module.exports = __webpack_public_path__ + "media/img/Landing_Page/profiling-purchase-page-a9de671705c6453a704cdfc54278aea1.png";